import * as React from "react";
import OpQuotesHeadingMfDsk, { IOpQuotesHeadingMfDskProps } from "../partials/opQuotesHeadingMfDsk";
import OpQuotesHoldings from "../partials/opQuotesHoldings";
import OpMarketDepthList from "../partials/opMarketDepthList";
import "../../../../../assets/scss/components/toc/orderPlacement/opQuotes/opQuotesTab.scss";
import moment from "moment";
import { toINR } from "../../../../service/numberFormat";

export interface IOpQuotesMfTabProps {
	quoteData: any;
	quoteDataExtra: any;
	holdingData?: any;
}

const OpQuotesMfTab: React.FC<IOpQuotesMfTabProps> = props => {
	const [showHoldings, setShowHoldings] = React.useState(false);
	const [showMarketDepth, setShowMarketDepth] = React.useState(false);

	const quotesHeadingProps: IOpQuotesHeadingMfDskProps = {
		SchemeName: props.quoteData.SchemeName,
		nav: props.quoteData.nav,
		changeinnav: props.quoteData.changeinnav,
		changeinnavper: props.quoteData.changeinnavper,
		navdateformat: props.quoteData.navdateformat
	};

	return (
		<div className="quotes_cont">
			<div className="quotes_cont_row va_start">
				<OpQuotesHeadingMfDsk {...quotesHeadingProps} />

				<button className="change_btn" onClick={console.log}>
					Change
				</button>
			</div>

			<div className="quotes_cont_row va_center">
				<div className="nav_change">
					<span className="nav">{props.quoteData.nav !== undefined ? props.quoteData.nav : "--"}</span>
					<span className="change green">{props.quoteData.changeinnav !== undefined ? props.quoteData.changeinnav : "--"}</span>
					<span className="change green">
						{props.quoteData.changeinnavper !== undefined ? `(${props.quoteData.changeinnavper}%)` : "--"}
					</span>
				</div>

				<div className="blue_btns">
					<div className="blue_btn_cont ib">
						{props.holdingData && (
							<button className="blue_btn" onClick={() => setShowHoldings(true)}>
								<i className="edel-icon-purse" /> {toINR(props.holdingData.units)} qty
							</button>
						)}

						{showHoldings && (
							<>
								<div className="popup_overlay" onClick={() => setShowHoldings(false)} />
								<div className="popup">
									<OpQuotesHoldings
										data={[
											{ label: "Current Value", value: `₹ ${toINR(+props.holdingData.units * +props.holdingData.nav)}` },
											{ label: "Units", value: toINR(props.holdingData.units) }
											// { label: "Unrealised G/L", value: "₹ 1,23,532.56 (12.34%)" }
										]}
										hldgOrPos="holding"
									/>
								</div>
							</>
						)}
					</div>
					<div className="blue_btn_cont ib">
						<button className="blue_btn" onClick={() => setShowMarketDepth(true)}>
							Market Depth
						</button>

						{showMarketDepth && (
							<>
								<div className="popup_overlay" onClick={() => setShowMarketDepth(false)} />
								<div className="popup">
									<OpMarketDepthList
										data={[
											{ label: "AUM (in Crs.)", value: toINR(props.quoteDataExtra.AUM) },
											{ label: "MorningStar Rating", value: props.quoteDataExtra.Rating || "0" },
											{ label: "Benchmark Index", value: props.quoteDataExtra.Benchmark || "--" },
											{ label: "Category", value: props.quoteDataExtra.Category || "--" },
											{
												label: "Inception Date",
												value: props.quoteDataExtra.InceptionDate ? moment(props.quoteDataExtra.InceptionDate).format("DD MMM YYYY") : "--"
											},
											{ label: "Risk Category", value: props.quoteDataExtra.RiskCategory || "--" },
											{ label: "3Yr Returns (%)", value: props.quoteDataExtra.Year3 ? `${props.quoteDataExtra.Year3}%` : "--" }
										]}
									/>
								</div>
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default OpQuotesMfTab;
